import { Checkbox } from "../ui/checkbox";
import { cn } from "../ui/utils";

interface MultiSelectOptionProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export function MultiSelectOption({ label, checked, onChange }: MultiSelectOptionProps) {
  return (
    <div
      className="px-4 py-2 hover:bg-gray-50 cursor-pointer flex items-center gap-2 **:data-[slot=checkbox]:scale-75 **:data-[slot=checkbox]:-m-2"
      onClick={() => onChange(!checked)}
    >
      <Checkbox
        checked={checked}
        onCheckedChange={onChange}
      />
      <div className="text-[#1D1B20] text-sm font-normal leading-5">
        {label}
      </div>
    </div>
  );
}

interface SingleSelectOptionProps {
  label: string;
  selected: boolean;
  onClick: () => void;
}

export function SingleSelectOption({ label, selected, onClick }: SingleSelectOptionProps) {
  return (
    <div
      className={cn(
        "px-4 py-3 hover:bg-gray-50 cursor-pointer",
        selected && "bg-blue-50"
      )}
      onClick={onClick}
    >
      <div className={cn(
        "text-base font-normal leading-6",
        selected ? "text-[#1B3647] font-medium" : "text-[#1B3647]"
      )}>
        {label}
      </div>
    </div>
  );
}
